import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Tooltip, TextField, Typography, InputAdornment } from "@material-ui/core";
import { Clear } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import KPTable from "../../../components/KPTable";
import PresentationUpdateModal from "../PresentationUpdateModal";
import PresentationDeleteModal from "../PresentationDeleteModal";
import {
  WorkflowStatusChip,
  RevisionRequestLink,
  RevisionRequestDialog,
  STATUS_META,
  workflowMetaColumns,
  WorkflowFilterBar,
  ExportExcelButton,
  applyConditions,
} from "../../../components/WorkflowStatus";

import { updatePresentation, acceptPresentation, requestRevisionPresentation } from "../../../reducer/presentation/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import PresentationHistoryModal from "../PresentationHistoryModal";

const deriveStatus = (row) => {
  if (row?.revisionStatus === "requested") return "revisionRequested";
  if (row?.revisionStatus === "resubmitted") return "resubmitted";
  if (row?.accepted) return "approved";
  return "pending";
};

function PresentationTable(props) {
  const [editting, setEditting] = useState(null);
  const [updating, setUpdating] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [historyRow, setHistoryRow] = useState(null);
  const [revisionRow, setRevisionRow] = useState(null);
  const [revisionSubmitting, setRevisionSubmitting] = useState(false);
  const [advancedConditions, setAdvancedConditions] = useState([]);
  useEffect(() => {
    setAdvancedConditions([]);
  }, [props.type]);

  const handleUpdate = (e) => setUpdating(e);
  const handleEditYear = (e) => setEditting(e);

  const handleDelete = (event, e) => {
    setDeleting(e.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (value) => setEditting({ ...editting, dashboardYear: value });

  const handleSubmit = (e) => {
    e.preventDefault();
    props.updatePresentation(editting.id, editting);
    setEditting(null);
  };

  const handleClear = () => {
    props.updatePresentation(editting.id, { ...editting, dashboardYear: null });
    setEditting(null);
  };

  const acceptPresentation = async (e) => {
    let result = await props.acceptPresentation(e.id, !e.accepted);
    return result;
  };

  const handleAccept = (e) => {
    acceptPresentation(e).then((success) => {
      if (success) {
        props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });
  };

  var list = [];
  if (props.type === "all") props.listPresentation.forEach((e) => list.push(e.presentation));
  else props.listPresentationById.forEach((e) => list.push(e.presentation));

  const columns = [
    // {
    //   title: <b>ID</b>,
    //   key: 'id',
    //   width: '10%',
    //   sorter: (a, b) => a.id - b.id,
    // },
    {
      title: <b>Tác vụ</b>,
      key: "action",
      width: "20%",
      render: (value, row) =>
        row?.id !== editting?.id ? (
          <>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="primary"
              onClick={() => handleUpdate(row)}
            >
              Chi tiết
            </Typography>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="primary"
              onClick={() => setHistoryRow(row)}
            >
              Lịch sử
            </Typography>
            {row.locked ? (
              <Typography className="table-action-buton" variant="caption" color="textPrimary">
                {`Đã khóa ${
                  (row.locked === "kpi" && "KPI") ||
                  (row.locked === "reward" && "thưởng") ||
                  (row.locked === "timeResearch" && "giờ nghiên cứu")
                }`}
              </Typography>
            ) : (
              <>
                {(props.type !== "all" || props.role === "sudo-admin") && !row.accepted && (
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="secondary"
                    onClick={(event) => handleDelete(event, row)}
                  >
                    Xoá
                  </Typography>
                )}
                {props.role === "sudo-admin" && row.purposeId !== 4 && (
                  <>
                    <Typography
                      className="table-action-buton"
                      variant="caption"
                      color="primary"
                      onClick={(event) => handleAccept(row)}
                    >
                      {row.accepted ? "Hủy duyệt" : "Duyệt"}
                    </Typography>
                    <RevisionRequestLink row={row} onClick={setRevisionRow} />
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <Typography className="table-action-buton" variant="caption" color="primary" onClick={handleSubmit}>
              Lưu
            </Typography>
            <Typography
              className="table-action-buton"
              variant="caption"
              color="secondary"
              onClick={() => setEditting(null)}
            >
              Huỷ
            </Typography>
          </>
        ),
    },
    {
      title: <b>Tên công trình</b>,
      key: "title",
      width: "30%",
      searchable: true,
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: <b>Phân loại</b>,
      key: "type",
      width: "20%",
      type: "include",
      filters: [
        {
          text: "Bài phỏng vấn, bài viết trên báo chí, talkshow, truyền hình",
          value: "interview_article",
        },
        {
          text: "Bài trình bày trong hội thảo quốc tế (có xuất bản kỷ yếu)",
          value: "international_seminar_paper",
        },
        {
          text: "Bài trình bày trong kỷ yếu hội thảo quốc gia",
          value: "national_seminar_paper",
        },
        {
          text: "Trình bày keynote tại Hội thảo khoa học quốc tế (tài liệu được in trong Kỷ yếu có giấy phép xuất bản)",
          value: "keynote_international_seminar",
        },
        {
          text: "Trình bày tại buổi sinh hoạt khoa học bộ môn/ trình bày tại hội nghị/hội thảo khoa học cấp khoa/viện; Tư vấn doanh nghiệp",
          value: "departmental_scientific_activities",
        },
        {
          text: "Trình bày tại Hội thảo khoa học quốc tế không có bài đăng kỷ yếu khoa học",
          value: "international_seminar_without_proceedings",
        },
        {
          text: "Trình bày tham luận tại Hội thảo khoa học quốc gia (tài liệu được in trong Kỷ yếu có giấy phép xuất bản)",
          value: "national_seminar_with_proceedings",
        },
        {
          text: "Trình bày/bài viết khoa học theo đơn đặt hàng của Trường hoặc của cơ quan trung ương",
          value: "scientific_presentation_by_order",
        },
      ],
      onFilter: (value, row) => row.filter((e) => value.includes(e.type)),
      render: (value) => {
        const type = {
          interview_article: "Bài phỏng vấn, bài viết trên báo chí, talkshow, truyền hình",
          international_seminar_paper: "Bài trình bày trong hội thảo quốc tế (có xuất bản kỷ yếu)",
          national_seminar_paper: "Bài trình bày trong kỷ yếu hội thảo quốc gia",
          keynote_international_seminar:
            "Trình bày keynote tại Hội thảo khoa học quốc tế (tài liệu được in trong Kỷ yếu có giấy phép xuất bản)",
          departmental_scientific_activities:
            "Trình bày tại buổi sinh hoạt khoa học bộ môn/ trình bày tại hội nghị/hội thảo khoa học cấp khoa/viện; Tư vấn doanh nghiệp",
          international_seminar_without_proceedings:
            "Trình bày tại Hội thảo khoa học quốc tế không có bài đăng kỷ yếu khoa học",
          national_seminar_with_proceedings:
            "Trình bày tham luận tại Hội thảo khoa học quốc gia (tài liệu được in trong Kỷ yếu có giấy phép xuất bản)",
          scientific_presentation_by_order:
            "Trình bày/bài viết khoa học theo đơn đặt hàng của Trường hoặc của cơ quan trung ương",
        };
        if (type[value]) return type[value];
        return "-";
      },
    },
    {
      title: <b>Tháng công bố</b>,
      key: "acceptedMonth",
      width: "12%",
      sorter: (a, b) => a.acceptedMonth - b.acceptedMonth,
    },
    {
      title: <b>Năm công bố</b>,
      key: "acceptedYear",
      width: "12%",
      sorter: (a, b) => a.acceptedYear - b.acceptedYear,
    },
    // props.role === "sudo-admin" && props.type === "all"
    //   ? {
    //       title: <b>Năm hiển thị</b>,
    //       key: "dashboardYear",
    //       width: "12%",
    //       searchable: true,
    //       render: (value, row) =>
    //         row?.id !== editting?.id ? (
    //           <Tooltip title="Click để chỉnh sửa năm">
    //             <div style={{ cursor: "pointer" }} onClick={() => handleEditYear(row)}>
    //               {value > 0 ? value : "Chưa có năm hiển thị"}
    //             </div>
    //           </Tooltip>
    //         ) : (
    //           <form onSubmit={handleSubmit}>
    //             <TextField
    //               fullWidth
    //               size="small"
    //               type="tel"
    //               variant="outlined"
    //               value={editting?.dashboardYear || ""}
    //               InputProps={{
    //                 endAdornment: (
    //                   <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={handleClear}>
    //                     <Clear style={{ fontSize: 18 }} />
    //                   </InputAdornment>
    //                 ),
    //               }}
    //               onChange={(e) => handleChange(parseInt(e.target.value))}
    //             />
    //           </form>
    //         ),
    //     }
    //   : {
    //       key: "dashboardYear",
    //       width: "0%",
    //       render: () => null,
    //     },
    {
      title: <b>Tình trạng</b>,
      key: "_status",
      width: "20%",
      render: (_, row) => <WorkflowStatusChip row={row} />,
      type: "include",
      filters: Object.entries(STATUS_META).map(([value, meta]) => ({ value, text: meta.label })),
      onFilter: (value, rows) => rows.filter((e) => value.includes(e._status)),
    },
    {
      title: <b>Mục đích</b>,
      key: "purposeId",
      width: "15%",
      type: "include",
      filters: props.purposes.map((e) => ({ value: e.id, text: e.description })),
      onFilter: (value, row) => row.filter((e) => value.includes(e.purposeId)),
      render: (value) => props.purposes.find((e) => e.id === value)?.description,
    },
    ...workflowMetaColumns({ width: "10%" }),
  ];

  if (props.volumnType === "all") columns.splice(2, 1);

  const enrichedRows = list.map((item) => ({ ...item, _status: deriveStatus(item) }));
  const filteredRows = applyConditions(enrichedRows, advancedConditions);
  const departmentName = (props.departments || []).find((d) => d.id === props.department)?.name;

  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 4 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <WorkflowFilterBar
            conditions={advancedConditions}
            onChange={setAdvancedConditions}
            rows={enrichedRows}
          />
        </div>
        <ExportExcelButton rows={filteredRows} workType="presentation" />
      </div>
      <KPTable
        shadow="none"
        rowsPerPage={10}
        maxHeight="calc(100vh - 320px)"
        columns={columns}
        rows={filteredRows}
        loading={props.isFetching}
      />
      <PresentationUpdateModal adminTab={props.adminTab} updating={updating} setUpdating={setUpdating} />
      <PresentationDeleteModal deleting={deleting} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
      <PresentationHistoryModal open={!!historyRow} row={historyRow} onClose={() => setHistoryRow(null)} />
      <RevisionRequestDialog
        row={revisionRow}
        submitting={revisionSubmitting}
        onClose={() => setRevisionRow(null)}
        onSubmit={async (reason) => {
          setRevisionSubmitting(true);
          const ok = await props.requestRevisionPresentation(revisionRow.id, reason);
          setRevisionSubmitting(false);
          if (ok) setRevisionRow(null);
        }}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  isFetching: select(state, "presentationReducer", "isFetching"),
  listProject: select(state, "projectReducer", "list"),
  listPresentation: select(state, "presentationReducer", "listFiltered"),
  listPresentationById: select(state, "presentationReducer", "listById"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  departments: select(state, "departmentReducer", "departments"),
});

const mapDispatchToProps = (dispatch) => ({
  acceptPresentation: (id, accept) => dispatch(acceptPresentation(id, accept)),
  requestRevisionPresentation: (id, reason) => dispatch(requestRevisionPresentation(id, reason)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  updatePresentation: (id, payload) => dispatch(updatePresentation(id, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(PresentationTable));

